import * as React from "react";
const SvgDuplicate = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#2D2D2D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.11}
      d="M10.95 8.658v3.098c0 2.586-1.033 3.619-3.62 3.619H4.244c-2.575 0-3.619-1.033-3.619-3.62V8.659c0-2.575 1.032-3.608 3.62-3.608h3.097c2.575 0 3.608 1.033 3.608 3.608m0 0v2.292h.806c2.586 0 3.619-1.032 3.619-3.62V4.234c0-2.575-1.033-3.608-3.608-3.608H8.67c-2.587 0-3.62 1.022-3.62 3.608v.817h2.28c2.588 0 3.62 1.033 3.62 3.608"
    />
  </svg>
);
export default SvgDuplicate;
